<template>
  <div :style="sandboxStyle">
    <!-- MULTI INPUT -->
    <TimelineComponent
      v-for="(input, inputKey) in inputtls"
      :key="input.timelineID"
    >
      <EndMarkerComponent
        :timelineID="input.timelineID"
        :time="input.end.time"
        :isInteractive="true"
      ></EndMarkerComponent>
      <MarbleComponent
        v-for="(marble, marbleKey) in input.marbles"
        :key="marble.marbleID"
        :marbleID="marble.marbleID"
        :time="marble.time"
        :isInteractive="true"
        :content="marble.content"
      ></MarbleComponent>
    </TimelineComponent>
    <!-- OPERATOR -->
    <div class="operatorBox">
      <div :style="before"></div>
      <span style="font-size: 1.5em; font-weight: 400">{{ label }}</span>
      <div :style="after"></div>
    </div>
    <!-- SINGLE OUTPUT -->
    <TimelineComponent>
      <EndMarkerComponent
        :timelineID="outputtl.timelineID"
        :time="outputtl.end.time"
        :isInteractive="false"
      ></EndMarkerComponent>
      <MarbleComponent
        v-for="(marble, marbleKey) in outputtl.marbles"
        :key="marble.marbleID"
        :marbleID="marble.marbleID"
        :time="marble.time"
        :isInteractive="false"
        :content="marble.content"
      ></MarbleComponent>
    </TimelineComponent>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import { map, tap } from "rxjs/operators";
import { Timeline } from "./data";
import { example$, inputTimelines$, outputTimeline$ } from "./rxMarble";
import { DIMENS, sandboxStyle, getElevationPseudoElementStyle } from "./styles";
import TimelineComponent from "./Timeline.vue";
import MarbleComponent from "./Marble.vue";
import EndMarkerComponent from "./EndMarker.vue";

const before = getElevationPseudoElementStyle("2px", "10px", "0.17");
const after = getElevationPseudoElementStyle("2px", "5px", "0.26");

const label = ref<string>("");
const inputtls = reactive<Timeline[]>([]);
let outputtl = reactive<Timeline>({
  timelineID: 0,
  marbles: [],
  end: { time: 0 },
  interactive: false
});

example$.pipe(tap((example) => (label.value = example.label))).subscribe();

inputTimelines$
  .pipe(
    map((timelines) => {
      inputtls.length = 0;
      timelines.forEach((timeline) => {
        inputtls.push(timeline);
      });
    })
  )
  .subscribe();

outputTimeline$
  .pipe(
    tap((timeline) => {
      Object.assign(outputtl, timeline);
    })
  )
  .subscribe();
</script>

<style>
.operatorBox {
  border: 1px solid rgba(0, 0, 0, 0.06);
  padding: v-bind("DIMENS.spaceMedium");
  text-align: center;
  position: relative;
}
svg {
  display: inline-block;
}
</style>
